require('./dist/program-badge/ds6/program-badge.css');
